export default __webpack_public_path__ + "images/segment_keep_going_illustration.2f662d19cea49faa90c26b2bc3e7a990.svg";